import * as React from 'react';

const ShareCartPopup = (props) => {
    const { SetStatus } = props;
    const onHide = () => {
        SetStatus(false)
    };
    return (
        <>
            <div className="avnet-modal modal-800">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close" data-dismiss="modal"
                        onClick={() => {
                            onHide()
                        }}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading">Share Cart</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body px-md-5 pb-4">
                        <div className="clearfix" />
                        <div className="mb-4">
                            <b>Share this link or enter email to share cart contents including quantity and part number.</b>
                        </div>
                        <div className="bs5 row gx-2">
                            <div className="col-12">
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Copy and share this link</label>
                                    <input type="text" className="form-control form-control-sm" id="email" placeholder="Link is required." name="name" />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Recipient Email</label>
                                    <input type="text" className="form-control form-control-sm" id="remail" placeholder="Email address is required." name="rname" />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Sender Email</label>
                                    <input type="text" className="form-control form-control-sm" id="semail" placeholder="Email address is required." name="sname" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-toggle="modal" data-target="#ShareModal"
                                onClick={() => {
                                    onHide()
                                }}>
                                CANCEL
                            </button>
                            <button type="button" className="bs5 btn btn-primary btn-sm w145" data-toggle="modal" data-target="#ShareModal">
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ShareCartPopup;